module.exports = global["_"] = require("-!./underscore.js");


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/lib/underscore.js
// module id = 56
// module chunks = 1